export enum ColorScheme {
  DarkCyan = '#132626',
  DarkGreen = '#193232',
  LightGrey = '#efefef',
  White = '#ffffff'
}

export default ColorScheme;
